import { render, staticRenderFns } from "./Onramp.vue?vue&type=template&id=7e101b08&"
import script from "./Onramp.vue?vue&type=script&lang=ts&"
export * from "./Onramp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports